export const environment = {
  production: true,
  apiUrl: 'https://api.hala.com',
  cdnBaseUrl: 'https://cdn.hala.com/website/'
};